import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Grid, Table, Pagination, Icon, Button } from 'semantic-ui-react';

import { ReactComponent as PlusIcon } from '../../assets/images/plus-icon.svg';

import ActionsPopup from './ActionsPopup';

import styles from './Items.module.scss';

const Items = React.memo(({ items, models, canView, canEdit, onAdd, onUpdate, onDelete }) => {
  const [t] = useTranslation();

  const [currentPage, setPage] = useState(1);
  const [data, setData] = useState([]);

  const resultsPerPage = 13;
  const totalPages = Math.ceil(items.length / resultsPerPage);

  const onPageChange = (e, { activePage }) => {
    setPage(activePage);
  };

  const dataTypesOptions = [
    { key: 0, value: 0, text: 'UINT16' },
    { key: 1, value: 1, text: 'UINT32' },
    { key: 2, value: 2, text: 'UINT64' },
    { key: 3, value: 3, text: 'INT16' },
    { key: 4, value: 4, text: 'INT32' },
    { key: 5, value: 5, text: 'INT64' },
  ];

  const orderbyOptions = [
    { key: 0, value: 0, text: 'AB' },
    { key: 1, value: 1, text: 'BA' },
    { key: 2, value: 2, text: 'ABCD' },
    { key: 3, value: 3, text: 'BADC' },
    { key: 4, value: 4, text: 'CDAB' },
    { key: 5, value: 5, text: 'DCBA' },
    { key: 6, value: 6, text: 'ABCD EFGH' },
    { key: 7, value: 7, text: 'EFGH ABCD' },
    { key: 8, value: 8, text: 'CDAB GHEF' },
    { key: 9, value: 9, text: 'DGHEF CDABCBA' },
  ];

  // const readWriteOptions = [
  //   { key: 0, value: 0, text: t('common.itemOptions.read') },
  //   { key: 1, value: 1, text: t('common.itemOptions.write') },
  //   { key: 2, value: 2, text: t('common.itemOptions.readWrite') },
  // ];

  useEffect(() => {
    setData(items.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage));
  }, [items, currentPage]);

  return (
    <>
      {canView && (
        <div className={styles.devicesWrapper}>
          <h2 className="page-title">{t('common.item')}</h2>
          <Grid verticalAlign="middle">
            <Grid.Column mobile={16} tablet={10} computer={12}>
              <h3 className="text-lg font-semibold text-gray">{t('common.using')}</h3>
            </Grid.Column>
            {canEdit && (
              <Grid.Column className="text-right" mobile={16} tablet={6} computer={4}>
                <button type="button" className={classNames(styles.itemButtonAdd)} onClick={onAdd}>
                  <PlusIcon className={styles.addGridIcon} />
                  {t('action.createItem')}
                </button>
              </Grid.Column>
            )}
          </Grid>
          <div className={styles.tableWrapper}>
            <Table singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.name')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.itemName')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.model')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.position')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.color')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.dataType')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.orderbyte')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.address')}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="uppercase text-xs text-grey">
                {t('common.items.startBit')}
              </Table.HeaderCell> */}
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.lengthBit')}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="uppercase text-xs text-grey">
                {t('common.items.spanHigh')}
              </Table.HeaderCell>
              <Table.HeaderCell className="uppercase text-xs text-grey">
                {t('common.items.spanLow')}
              </Table.HeaderCell> */}
                  {/* <Table.HeaderCell className="uppercase text-xs text-grey">
                {t('common.items.initialValue')}
              </Table.HeaderCell> */}
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.scanRate')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.unitName')}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="uppercase text-xs text-grey">
                {t('common.items.readWrite')}
              </Table.HeaderCell> */}
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.isIntegral')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.isSum')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.isBasic')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.update')}
                  </Table.HeaderCell>
                  {canEdit && (
                    <Table.HeaderCell className="uppercase text-xs text-grey">
                      {t('common.items.action')}
                    </Table.HeaderCell>
                  )}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {data.map((item) => {
                  return (
                    <Table.Row key={item.id}>
                      <Table.Cell>
                        <div className={`flex items-center ${styles.itemNameWrapper}`}>
                          <div className={styles.item_name_desc}>
                            <span className={styles.itemName}>{item.name}</span>
                          </div>
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>{item.itemName}</span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>{item.deviceModel?.name || ''}</span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>{item.position || ''}</span>
                      </Table.Cell>
                      <Table.Cell style={{ backgroundColor: item.color }} />
                      <Table.Cell>
                        <span className={styles.item}>{dataTypesOptions[item.dataType].text}</span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>{orderbyOptions[item.orderbyte].text}</span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>{item.address}</span>
                      </Table.Cell>
                      {/* <Table.Cell>
                    <span className={styles.item}>{item.startBit}</span>
                  </Table.Cell> */}
                      <Table.Cell>
                        <span className={styles.item}>{item.lengthBit}</span>
                      </Table.Cell>
                      {/* <Table.Cell>
                    <span className={styles.item}>{item.spanHigh}</span>
                  </Table.Cell>
                  <Table.Cell>
                    <span className={styles.item}>{item.spanLow}</span>
                  </Table.Cell> */}
                      {/* <Table.Cell>
                    <span className={styles.item}>{item.initialValue}</span>
                  </Table.Cell> */}
                      <Table.Cell>
                        <span className={styles.item}>{item.scanRate}</span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>{item.unitName}</span>
                      </Table.Cell>
                      {/* <Table.Cell>
                    <span className={styles.item}>{readWriteOptions[item.readWrite].text}</span>
                  </Table.Cell> */}
                      <Table.Cell>
                        <span className={styles.item}>
                          {item.isIntegral
                            ? t('common.itemOptions.yes')
                            : t('common.itemOptions.no')}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>
                          {item.isSum ? t('common.itemOptions.yes') : t('common.itemOptions.no')}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item}>
                          {item.basic ? t('common.itemOptions.yes') : t('common.itemOptions.no')}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className={styles.item_update}>
                          {t('format:longDateTime', {
                            postProcess: 'formatDate',
                            value: new Date(item.updatedAt || item.createdAt),
                          })}
                        </span>
                      </Table.Cell>
                      {canEdit && (
                        <Table.Cell>
                          <ActionsPopup
                            models={models}
                            item={item}
                            onUpdate={onUpdate}
                            onDelete={onDelete}
                          >
                            <Button
                              content={item.name}
                              disabled={!canEdit}
                              className={styles.name}
                            />
                          </ActionsPopup>
                        </Table.Cell>
                      )}
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
          <div className={`text-right ${styles.pagination_wrapper}`}>
            <Pagination
              activePage={currentPage}
              boundaryRange={0}
              onPageChange={onPageChange}
              size="mini"
              siblingRange={1}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              firstItem={{ content: <Icon name="angle double left" />, icon: true }}
              lastItem={{ content: <Icon name="angle double right" />, icon: true }}
              totalPages={totalPages}
            />
          </div>
        </div>
      )}
    </>
  );
});

Items.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  models: PropTypes.arrayOf(PropTypes.any).isRequired,
  canView: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default Items;
